import * as yup from 'yup';
export const ownerCreationSchema = yup.object({
    hubspotId: yup
        .string()
        .required('HubSpot ID is required')
        .min(3, 'HubSpot ID must be at least 3 characters')
        .max(255, 'HubSpot ID must not exceed 255 characters'),
    name: yup
        .string()
        .required('Name is required')
        .min(2, 'Name must be at least 2 characters')
        .max(255, 'Name must not exceed 255 characters'),
    notes: yup
        .string()
        .max(5000, 'Notes must not exceed 5000 characters')
        .nullable()
        .default(null),
    canCreateCompanies: yup.boolean().default(false),
    canCreateLicenses: yup.boolean().default(false),
    canProvisionEgressSeats: yup.boolean().default(false),
    maxTotalLicenses: yup
        .number()
        .nullable()
        .transform((value, originalValue) => originalValue === '' || originalValue === null ? null : value)
        .positive('Must be a positive number')
        .integer('Must be a whole number')
        .default(null),
    maxTotalSeats: yup
        .number()
        .nullable()
        .transform((value, originalValue) => originalValue === '' || originalValue === null ? null : value)
        .positive('Must be a positive number')
        .integer('Must be a whole number')
        .default(null),
    maxSeatsPerLicense: yup
        .number()
        .nullable()
        .transform((value, originalValue) => originalValue === '' || originalValue === null ? null : value)
        .positive('Must be a positive number')
        .integer('Must be a whole number')
        .default(null),
    licenseValidityLength: yup
        .number()
        .required('License Validity Length is required')
        .integer('Must be a whole number')
        .min(1, 'Must be at least 1 year')
        .max(10, 'Must not exceed 10 years'),
});
